/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Filter_Roles_AnyInputs */

const cs_clients_filter_roles_any = /** @type {(inputs: Clients_Filter_Roles_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kterákoli z těchto rolí`)
};

const en_clients_filter_roles_any = /** @type {(inputs: Clients_Filter_Roles_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any of these roles`)
};

/**
* | output |
* | --- |
* | "Any of these roles" |
*
* @param {Clients_Filter_Roles_AnyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_filter_roles_any = /** @type {((inputs?: Clients_Filter_Roles_AnyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Filter_Roles_AnyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_filter_roles_any(inputs)
	return cs_clients_filter_roles_any(inputs)
});